import { render, staticRenderFns } from "./MonthlyDetailsTable.vue?vue&type=template&id=2392038c&scoped=true&"
import script from "./MonthlyDetailsTable.vue?vue&type=script&lang=js&"
export * from "./MonthlyDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyDetailsTable.vue?vue&type=style&index=0&id=2392038c&prod&scoped=true&lang=css&"
import style1 from "@/assets/css/customerHome.css?vue&type=style&index=1&id=2392038c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2392038c",
  null
  
)

export default component.exports